<template>
  <div>
    <div class="slotcL">
      <div class="serch">
        <div
          v-for="items in searchList"
          :key="items.id"
          class="selese_item"
        >
          <div>
            <el-input
              v-if="items.type == 1 && (items.fixed || items.show)"
              v-model="items.value"
              :style="{ width: (items.width || 220) + 'px' }"
              :class="[{ 'custom-picker': items.show }]"
              :maxlength="items.limit"
              :show-word-limit="items.limit"
              clearable
              :placeholder="items.placeholder || proxy.$t('Shared.pleaseEnter') + (items.pla || '')"
              @keyup.enter="handleQuery(1)"
            >
              <template #prefix>
                {{ items.title }}：
              </template>
            </el-input>
            <!--2： 选择器 -->
            <el-select
              v-if="items.type == 2 && (items.fixed || items.show)"
              v-model="items.value"
              :style="{ width: 230 + 'px' }"
              :class="[{ 'custom-picker': items.show && !items.fixed }]"
              clearable
              :placeholder="proxy.$t('Shared.pleaseChoose')"
              collapse-tags
              :multiple="items.multiple"
            >
              <template #prefix>
                {{ items.title }}：
              </template>
              <template #append>
                <el-icon><Close /></el-icon>
              </template>
              <el-option
                v-for="item in items.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>

            <!-- 右边：日期范围选择器（带文字前缀） -->
            <div
              v-if="items.type > 2 && items.type != 7 && items.type != 98 && items.type != 99 && (items.fixed || items.show)"
              :class="['custom-date-picker-group', { active: items.show && !items.fixed, 'cascader-group': items.type == 8 }]"
            >
              <!-- 前缀部分 -->
              <div class="el-input-group__prepend">
                {{ items.title }}：
              </div>
              <el-date-picker
                v-if="items.type == 3 && (items.fixed || items.show)"
                v-model="items.value"
                prefix-icon="custom-prefix-text"
                type="date"
                :value-format="format"
                :format="format"
                clearable
                placeholder="请选择"
                @change="handleQuery(1)"
              >
                <template #prefix>
                  {{ items.title }}：
                </template>
              </el-date-picker>
              <!--4： 日期范围选择器 -->
              <el-date-picker
                v-if="items.type == 4 && (items.fixed || items.show)"
                v-model="items.value"
                prefix-icon="custom-prefix-text"
                :value-format="format"
                :format="format"
                type="daterange"
                clearable
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleQuery(1)"
              />
              <!-- 5：日期时间选择器 -->
              <el-date-picker
                v-if="items.type == 5 && (items.fixed || items.show)"
                v-model="items.value"
                :value-format="formatData"
                :format="formatData"
                prefix-icon="custom-prefix-text"
                type="datetime"
                clearable
                placeholder="请选择"
                @change="handleQuery(1)"
              />

              <!--6:日期时间 范围选择器  -->
              <el-date-picker
                v-if="items.type == 6 && (items.fixed || items.show)"
                v-model="items.value"
                style="width: 360px"
                :value-format="formatData"
                :format="formatData"
                clearable
                :shortcuts="items.shortcuts || pickerOptions.shortcuts"
                prefix-icon="custom-prefix-text"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleQuery(1)"
              />
              <!-- 多选 -->
              <el-cascader
                v-if="items.type == 8 && (items.fixed || items.show)"
                v-model="items.value"
                multiple
                clearable
                :placeholder="proxy.$t('Shared.pleaseChoose')"
                :show-all-levels="false"
                :options="items.options"
                :props="{ value: 'id', emitPath: false }"
                @change="handleQuery(1)"
              />
            </div>

            <!-- 数字输入框 -->
            <el-input
              v-if="items.type == 7 && (items.fixed || items.show)"
              v-model="items.value"
              :style="{ width: 200 + 'px' }"
              :class="[{ 'custom-picker': items.show }]"
              clearable
              type="number"
              :placeholder="proxy.$t('Shared.pleaseEnter')"
            >
              <template #prefix>
                {{ items.title }}：
              </template>
            </el-input>

            <store-select
              v-if="items.type == 99 && (items.fixed || items.show)"
              v-model="items.value"
              :class="[{ 'custom-picker': items.show && !items.fixed }]"
              :title="items.title"
              :width="items.width || 230"
              :panel-width="items.panelWidth"
              :multiple="items.multiple !== false"
              :option-types="items.optionTypes || items.types || ['shop']"
              :only-type="items.onlyType || ''"
              :one-type-only="items.oneTypeOnly"
              :tabs="items.tabs || []"
              :link-params="items.linkParams || {}"
              :status-list="items.statusList || [1, 2, 3, 4, 5]"
              :page-size="items.pageSize || 10"
              @change="items.multiple === false && handleQuery(1)"
              @close="items.multiple !== false && handleQuery(1)"
            />

            <staff-select
              v-if="items.type == 98 && (items.fixed || items.show)"
              v-model="items.value"
              :class="[{ 'custom-picker': items.show && !items.fixed }]"
              :title="items.title"
              :width="items.width || 230"
              :panel-width="items.panelWidth"
              :multiple="items.multiple !== false"
              :link-params="items.linkParams || {}"
              :id-key="items.idKey || 'userId'"
              :name-key="items.nameKey || 'nickName'"
              :page-size="items.pageSize || 10"
              @change="items.multiple === false && handleQuery(1)"
              @close="items.multiple !== false && handleQuery(1)"
            />
          </div>
          <!-- 动态标题 -->
          <div
            v-if="(items.fixed || items.show) && items.titleType == 2"
            class="title"
          >
            <el-dropdown>
              <span class="el-dropdown-link"> {{ items.title }}<i class="el-icon-arrow-down el-icon--right" /> </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    v-for="item in items.titleOption"
                    :key="item.value ?? item.label"
                  >
                    {{ item.label }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>

          <!-- 删除 -->
          <div
            v-if="!items.fixed && items.show"
            class="unit"
            @click="delFn(items.id)"
          >
            <el-icon><Close /></el-icon>
          </div>
        </div>
        <div v-if="!pushBtb">
          <el-button
            icon="Refresh"
            :disabled="loading"
            @click="reseveFn(2)"
          >
            {{ proxy.$t('Shared.Reset') }}
          </el-button>
          <el-button
            type="primary"
            icon="Search"
            :loading="loading"
            @click="handleQuery(1)"
          >
            {{ proxy.$t('Shared.Query') }}
          </el-button>
        </div>
        <div
          v-if="pushBtb && hasAvailableFilters"
          class="pushBtbBox"
        >
          <el-dropdown
            trigger="click"
            @command="handleCommand"
          >
            <el-button icon="Plus">
              添加筛选
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <div
                  v-for="(item, i) in localSearchDate"
                  v-show="!item.fixed && !item.show"
                  :key="item.id"
                >
                  <el-dropdown-item :command="i">
                    <div class="dropdownC">
                      {{ item.title }}
                    </div>
                  </el-dropdown-item>
                </div>
                <div v-show="localSearchDate.length == searchList.length">
                  <el-dropdown-item>
                    <el-empty description="暂无其他筛选" />
                  </el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
      <slot name="button" />
    </div>
    <div
      v-if="pushBtb"
      class="pushBtb"
    >
      <div>
        <span>
          <!-- 缓存数据 -->
          <div
            v-for="(item, i) in localSearchList"
            :key="i"
            :class="['setSearch', activeIndex == i ? 'active' : '']"
            @click="onActive(i, item)"
          >
            {{ item.name }}
            <el-dropdown
              class="gengdou"
              @command="listPushFn($event, i, item)"
            >
              <el-icon><MoreFilled /></el-icon>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    class="iseditdel"
                    :command="1"
                  >编辑</el-dropdown-item>
                  <el-dropdown-item
                    class="iseditdel"
                    :command="3"
                  >删除</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </span>
        <el-button
          v-show="isSave"
          icon="tickets"
          @click="listPushFn(2)"
        >
          保存快捷筛选项
        </el-button>
      </div>
      <div>
        <el-button
          icon="Refresh"
          :disabled="loading"
          @click="reseveFn(2)"
        >
          重置
        </el-button>
        <el-button
          type="primary"
          icon="Search"
          :loading="loading"
          @click="handleQuery(1)"
        >
          查询
        </el-button>
      </div>
    </div>
    <div
      v-if="pushBtb"
      class="xiao"
    />
    <el-dialog
      v-model="outerVisible"
      width="700px"
      :title="centerTitle"
      @close="closeFn"
    >
      <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item
          label="快捷筛选名称"
          prop="name"
        >
          <el-input
            v-model="ruleForm.name"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeFn">取 消</el-button>
          <el-button
            type="primary"
            @click="storagelocalSearchList"
          >确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, onMounted, ref, watch, type ComponentInternalInstance } from 'vue';
import StaffSelect from './StaffSelect.vue';
import StoreSelect from './StoreSelect.vue';
const { proxy } = getCurrentInstance() as ComponentInternalInstance;
const emits = defineEmits(['search']);
// ✅ 严格类型定义（解决TS报错核心）
interface Props {
  isKey: string; // 弹窗显隐
  searchDate: any; // 原始图片地址
  pushBtb: boolean;
  nullValue: boolean;
  clearable: boolean;
  isSave?: boolean;
  loading?: boolean;
}
// 2. 使用 withDefaults 设置默认值
const props = withDefaults(defineProps<Props>(), {
  isSave: true,
  loading: false,
});
const editIndex = ref(-1);
const localSearchList = ref([]);
// 筛选配置在组件内维护，避免直接修改父组件传入的数据。
const localSearchDate = ref(JSON.parse(JSON.stringify(props.searchDate || [])));
watch(
  () => props.searchDate,
  (searchDate) => {
    // 异步选项和文案更新按 id 合并，保留用户已输入的值及动态筛选显隐。
    const nextDate = JSON.parse(JSON.stringify(searchDate || []));
    localSearchDate.value = nextDate.map((item) => {
      const current = searchList.value.find((entry) => entry.id === item.id);
      const previous = localSearchDate.value.find((entry) => entry.id === item.id);
      return current ? { ...item, value: current.value, show: current.show } : { ...item, show: previous?.show ?? item.show };
    });
    searchList.value = localSearchDate.value.filter((item) => item.fixed || item.show);
  },
  { deep: true },
);
const searchList = ref([]);
const SearchKeyData = ref([]);
const activeIndex = ref(-1);
// 仅存在尚未展示的动态筛选项时显示“添加筛选”按钮。
const hasAvailableFilters = computed(() => localSearchDate.value.some((item) => !item.fixed && !item.show));
const ruleForm = ref({ name: '' });
const ruleFormRef = ref(null);
const outerVisible = ref(false);
const centerTitle = ref('修改快捷筛选名称');
const format = ref('YYYY-MM-DD');
const formatData = ref('YYYY-MM-DD HH:mm:ss');
const rules = ref({
  name: [
    {
      validator: (_validationRule, value, callback) => {
        if (!value || !value.trim()) {
          callback(new Error('请输入快捷筛选名称'));
        } else if (value.trim().length < 1 || value.trim().length > 8) {
          callback(new Error('长度在 1 到 8 个字符'));
        } else {
          callback();
        }
      },
      trigger: 'blur',
    },
  ],
});
const getShortcutRange = (days) => {
  const start = new Date();
  start.setDate(start.getDate() - days + 1);
  start.setHours(0, 0, 0, 0);
  const end = new Date();
  end.setHours(23, 59, 59, 999);
  return [start, end];
};
const pickerOptions = ref({
  shortcuts: [
    { text: '今天', value: () => getShortcutRange(1) },
    { text: '近三天', value: () => getShortcutRange(3) },
    { text: '近一周', value: () => getShortcutRange(7) },
    { text: '近一个月', value: () => getShortcutRange(30) },
  ],
});

onMounted(() => {
  info();

});
// 关闭弹窗时同步清空表单值与校验状态，避免再次打开时残留错误提示。
function closeFn() {
  outerVisible.value = false;
  ruleForm.value.name = '';
  ruleFormRef.value?.clearValidate();
}
// 初始化
function info() {
  SearchKeyData.value = localStorage.getItem('localSearchList') ? JSON.parse(localStorage.getItem('localSearchList')) : [];
  const targetItem = SearchKeyData.value.find((item) => item.key === props.isKey);
  reseveFn(1);
  if (targetItem) {
    // 缓存存在
    localSearchList.value = JSON.parse(JSON.stringify(targetItem.list));
  }
}
// 本地缓存
function storagelocalSearchList() {
  // searchList
  ruleFormRef.value.validate((valid) => {
    if (valid) {
      if (props.isKey) {
        const List = SearchKeyData.value.filter((savedItem) => savedItem.key !== props.isKey);
        if (editIndex.value > -1) {
          localSearchList.value[editIndex.value] = { name: ruleForm.value.name, list: JSON.parse(JSON.stringify(searchList.value)) };
        } else {
          localSearchList.value.push({ name: ruleForm.value.name, list: JSON.parse(JSON.stringify(searchList.value)) });
        }
        List.push({ key: props.isKey, list: localSearchList.value });
        localStorage.setItem('localSearchList', JSON.stringify(List));
        outerVisible.value = false;
        ruleForm.value.name = '';
      }
    }
  });
}

// 选项
function onActive(e, item) {
  if (props.loading) return;
  activeIndex.value = activeIndex.value == e ? -1 : e;
  if (activeIndex.value == -1) {
    reseveFn(2);
  } else {
    searchList.value = JSON.parse(JSON.stringify(item.list));
    handleQuery();
    const titleList = searchList.value.map((v) => {
      return v.title;
    });
    localSearchDate.value.forEach((v) => {
      v.show = titleList.indexOf(v.title) > -1;
    });
  }
}

function reseveFn(e) {
  if (e == 2 && props.loading) return;
  searchList.value = [];
  activeIndex.value = -1;
  localSearchDate.value.forEach((v) => {
    v.show = false;
    if (!v.fixed || e == 2) {
      clearItemValue(v);
    }
  });
  searchList.value = JSON.parse(
    JSON.stringify(
      localSearchDate.value.filter((v) => {
        return v.fixed;
      }),
    ),
  );
  if (e == 2) {
    reseve();
  }
}
function getSelectedList(value) {
  if (Array.isArray(value)) {
    return value;
  }
  return value ? [value] : [];
}
function getStoreSelectedList(item, type = '') {
  const list = getSelectedList(item.value);
  return type ? list.filter((store) => store.type === type) : list;
}
function getStoreFieldValue(item, type = '') {
  const ids = getStoreSelectedList(item, type).map((store) => store.id);
  return item.multiple === false ? (ids[0] ?? '') : ids;
}
function getStoreTypeValue(item) {
  const types = [
    ...new Set(
      getStoreSelectedList(item)
        .map((store) => store.type)
        .filter(Boolean),
    ),
  ];
  return item.multiple === false || item.oneTypeOnly ? types[0] || '' : types;
}
function getStaffFieldValue(item) {
  const list = getSelectedList(item.value);
  const ids = list.map((staff) => staff.id ?? staff.value).filter((id) => id !== undefined && id !== null && id !== '');
  if (item.multiple === false) {
    return ids[0] ?? '';
  }
  return ids;
}
function getFieldValue(item) {
  if (item.type == 99) {
    return getStoreFieldValue(item);
  }
  if (item.type == 98) {
    return getStaffFieldValue(item);
  }
  return item.value;
}
function applyStoreSelectFields(obj, item) {
  const fieldMap = item.fieldNameMap || item.typeFieldMap;
  if (fieldMap && typeof fieldMap === 'object') {
    Object.keys(fieldMap).forEach((type) => {
      setObjectField(obj, fieldMap[type], getStoreFieldValue(item, type));
    });
  } else {
    setObjectField(obj, item.fieldName, getStoreFieldValue(item));
  }
  if (item.typeFieldName) {
    setObjectField(obj, item.typeFieldName, getStoreTypeValue(item));
  }
}
// 回调时保留空值的数据类型，避免空数组或空对象被转换成 null。
function normalizeCallbackValue(value) {
  if (Array.isArray(value)) {
    return value.length ? value : [];
  }
  if (value !== null && typeof value === 'object') {
    return Object.keys(value).length ? value : {};
  }
  if (value === undefined || value === null || value === '' || (typeof value === 'number' && Number.isNaN(value))) {
    return null;
  }
  return value;
}

function setObjectField(obj, fieldName, value) {
  if (!fieldName) return;
  const keys = fieldName.split('.');
  let current = obj;
  for (let i = 0; i < keys.length; i++) {
    if (i === keys.length - 1) {
      current[keys[i]] = normalizeCallbackValue(value);
    } else {
      if (!current[keys[i]]) {
        current[keys[i]] = {};
      }
      current = current[keys[i]];
    }
  }
}
function reseve() {
  const obj = {};
  console.log('reseve', localSearchDate.value);
  localSearchDate.value.forEach((v) => {
    // 标题数据
    if (v.titleType == 2) {
      obj[v.titleName] = normalizeCallbackValue(v.titleValue);
    }
    if (v.type == 4 || v.type == 6) {
      const rangeValue = Array.isArray(v.value) ? v.value : [];
      obj[v.fieldName[0]] = normalizeCallbackValue(rangeValue[0]);
      obj[v.fieldName[1]] = normalizeCallbackValue(rangeValue[1]);
    } else if (v.type == 99) {
      applyStoreSelectFields(obj, v);
    } else {
      setObjectField(obj, v.fieldName, getFieldValue(v));
    }
  });
  emits('search', obj);
}
// 自定义选择器没有 disabled 契约，加载期间保留最后一次查询，结束后再提交。
const pendingQuery = ref<Record<string, any> | null>(null);
watch(
  () => props.loading,
  (loading) => {
    if (!loading && pendingQuery.value) {
      const query = pendingQuery.value;
      pendingQuery.value = null;
      emits('search', query);
    }
  },
);
// 搜索
function handleQuery() {
  const obj = {};

  searchList.value.forEach((v) => {
    // 标题数据
    if (v.titleType == 2) {
      obj[v.titleName] = normalizeCallbackValue(v.titleValue);
    }
    if (v.type == 4 || v.type == 6) {
      const rangeValue = Array.isArray(v.value) ? v.value : [];
      obj[v.fieldName[0]] = normalizeCallbackValue(rangeValue[0]);
      obj[v.fieldName[1]] = normalizeCallbackValue(rangeValue[1]);
    } else if (v.type == 99) {
      applyStoreSelectFields(obj, v);
    } else {
      setObjectField(obj, v.fieldName, getFieldValue(v));
    }
  });

  if (props.loading) {
    pendingQuery.value = JSON.parse(JSON.stringify(obj));
    return;
  }
  pendingQuery.value = null;
  emits('search', obj);
}
// 保存快捷
function listPushFn(e, i, item) {
  if (e == 1) {
    centerTitle.value = '修改快捷筛选名称';
    outerVisible.value = true;
    editIndex.value = i;
    ruleForm.value.name = item.name;
  } else if (e == 2) {
    centerTitle.value = '将当前筛选条件保存为快捷筛选';
    outerVisible.value = true;
    editIndex.value = -1;
  } else {
    // 删除
    localSearchList.value.splice(i, 1);
    const List = SearchKeyData.value.filter((savedItem) => savedItem.key !== props.isKey);
    List.push({ key: props.isKey, list: localSearchList.value });
    localStorage.setItem('localSearchList', JSON.stringify(List));
  }
}
function handleCommand(e) {
  console.log('e-------', e);

  localSearchDate.value[e].show = true;
  searchList.value.push(localSearchDate.value[e]);
}
function getEmptyValue(item) {
  if (item.type == 4 || item.type == 6 || item.type == 8 || item.type == 98 || item.type == 99 || item.multiple) {
    return [];
  }
  return '';
}

function clearItemValue(item) {
  if (item) {
    item.value = getEmptyValue(item);
  }
}

// 删除搜索
function delFn(e) {
  if (props.loading) return;
  searchList.value.forEach((v) => {
    if (v.id === e) {
      clearItemValue(v);
    }
  });
  searchList.value = searchList.value.filter((v) => v.id !== e);
  localSearchDate.value.forEach((v) => {
    if (v.id == e) {
      v.show = false;
      clearItemValue(v);
    }
  });
  handleQuery();
}

// 暴露给父页面，在新增或编辑返回列表时重置筛选条件。
defineExpose({
  reset: () => reseveFn(2),
});
</script>

<style scoped lang="scss">
// 时间选择器
.custom-date-picker-group {
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--el-border-color);
  border-radius: var(--el-border-radius-base);
  overflow: hidden;
  background-color: var(--el-fill-color-blank);
  &.active {
    padding-inline-end: 20px;
  }
  /* 前缀样式 */
  .el-input-group__prepend {
    padding-inline-start: 10px;
    padding-inline-end: 0px;
    background-color: var(--el-fill-color-blank);
    color: var(--el-text-color-regular);
    // border-right: 1px solid var(--el-border-color);
    height: 100%;
    display: flex;
    align-items: center;
    white-space: nowrap;
    font-size: 14px;
    white-space: nowrap;
    line-height: var(--el-input-inner-height);
    text-align: center;
    color: var(--el-input-icon-color, var(--el-text-color-placeholder));
    transition: all var(--el-transition-duration);
    pointer-events: none;
    flex-wrap: nowrap;
    flex-shrink: 0;
    display: inline-flex;
  }

  /* 去掉 el-date-picker 自身的边框，使其融入整体 */
  :deep(.el-date-picker.el-input .el-input__wrapper),
  :deep(.el-date-editor .el-input__wrapper) {
    box-shadow: none !important; /* 移除内部阴影 */
    border-radius: 0; /* 去掉圆角 */
    border: none;
  }

  /* 级联分类复用外层边框，避免内部输入框再次绘制边框。 */
  &.cascader-group {
    :deep(.el-cascader .el-input__wrapper) {
      box-shadow: none !important;
      border: none;
      border-radius: 0;
    }
  }

  :deep(.el-date-editor) {
    box-shadow: none !important; /* 移除内部阴影 */
    border-radius: 0; /* 去掉圆角 */
    border: none;
  }
  /* 确保 hover 状态下的边框不溢出 */
  &:hover {
    border-color: var(--el-color-primary);
  }
}

.date-range-input {
  width: 100%;
}

.date-range-picker {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.slotcL {
  display: flex;
  justify-content: space-between;
}

.dropdownC {
  padding: 0 30px;
  text-align: center;
}

.serch {
  display: flex;
  flex-wrap: wrap;
}

.selese_item {
  position: relative;
  margin-right: 8px;
  margin-bottom: 16px;

  //   :deep(.el-input__inner) {
  //     padding-right: 16px !important;
  //   }

  .custom-picker {
    :deep(.el-input__wrapper),
    :deep(.el-select__wrapper) {
      padding-right: 35px !important;
    }
  }

  //   ::v-deep .el-date-editor .el-range-input {
  //     width: 50% !important;
  //   }

  .unit {
    position: absolute;
    // right: 0;
    inset-inline-end: 0;
    // z-index: 99999999 !important;
    color: var(--el-text-color-secondary);
    top: 0;
    width: 29px;
    height: 32px;
    line-height: 38px;
    text-align: center;
    border-inline-start: 1px solid var(--el-border-color);
    &:hover {
      color: var(--el-color-primary);
    }
  }

  .title {
    position: absolute;
    left: 10px;
    color: var(--el-text-color-primary);
    top: 0;
    z-index: 2;
    line-height: 32px;
    font-size: 14px;
    text-align: center;

    .el-dropdown-link {
      position: relative;
      right: 5px;
    }
  }
  .pushBtbBox {
    margin: 0 10px;
  }
}

.pushBtb {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 15px 0;
  border-top: 1px solid var(--el-border-color);
  margin-top: 5px;

  .setSearch {
    padding-left: 38px !important;
    padding-right: 38px !important;
    position: relative;
    display: inline-block;
    border: 1px solid var(--el-border-color);
    height: 100%;
    line-height: 32px;
    margin-right: 10px;
    border-radius: 5px;

    .gengdou {
      position: absolute;
      right: 3px;
      display: none;
      transform: rotate(90deg);
      border: none;
      padding: 8px 3px;
      color: var(--el-color-primary);
    }

    &:hover {
      cursor: pointer;
      color: var(--el-color-primary);

      .gengdou {
        display: inline-block !important;
      }
    }

    .iseditdel {
      padding: 0 50px;
      color: var(--el-color-danger) !important;
    }
  }

  .active {
    color: var(--el-color-primary);
    border: 1px solid var(--el-color-primary);
  }
}

.xiao {
  background-color: var(--el-fill-color-light);
  width: 120%;
  height: 8px;
  position: relative;
  left: -50px;
  margin-bottom: 10px;
}
</style>
